// 細部（decisions/17-sensory の採用版）。
// 紙の粒子と時刻の光、押したときの波紋、葉を摘む ／ Herbarium（標本箱）。
// どれも飾りなので、失敗しても買い物の動きは止めない（例外はこのファイルの中で閉じる）。
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function store(k, v) {
    try {
      if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null');
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  }
  function prng(s) { return function () { s |= 0; s = s + 0x6D2B79F5 | 0; var t = Math.imul(s ^ s >>> 15, 1 | s); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  /* ---------- 紙の粒子と時刻の光 ---------- */
  var paper = $('.paper');
  // 粒は 2px、#DEDEDE の上で最大 7 段階だけ暗くする灰色。紙のむらのうねりと、和紙の繊維の短い線を足す
  function grain() {
    var S = 192, G = 96, B = 16, AMP = 7, BLOT = 0.5, FIBERS = 16, r = prng(20261003), g = [], i, x, y;
    var small = document.createElement('canvas'); small.width = small.height = G;
    var sx = small.getContext('2d'), im = sx.createImageData(G, G), px = im.data;
    for (i = 0; i < B * B; i++) g.push(r() * 2 - 1);
    for (y = 0; y < G; y++) for (x = 0; x < G; x++) {
      var gx = x / G * B, gy = y / G * B, x0 = Math.floor(gx), y0 = Math.floor(gy), fx = gx - x0, fy = gy - y0, x1 = (x0 + 1) % B, y1 = (y0 + 1) % B;
      fx = fx * fx * (3 - 2 * fx); fy = fy * fy * (3 - 2 * fy);
      var top = g[y0 * B + x0] + (g[y0 * B + x1] - g[y0 * B + x0]) * fx, bot = g[y1 * B + x0] + (g[y1 * B + x1] - g[y1 * B + x0]) * fx;
      var v = Math.max(-1, Math.min(1, (r() + r() - 1) * 0.8 + (top + (bot - top) * fy) * BLOT));
      var gv = Math.round(255 - Math.max(0, v) * AMP * 255 / 222), j = (y * G + x) * 4;
      px[j] = px[j + 1] = px[j + 2] = gv; px[j + 3] = 255;
    }
    sx.putImageData(im, 0, 0);
    var c = document.createElement('canvas'); c.width = c.height = S;
    var ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, S, S);
    ctx.imageSmoothingEnabled = true; ctx.drawImage(small, 0, 0, S, S);
    ctx.lineCap = 'round';
    for (i = 0; i < FIBERS; i++) {
      var f0x = r() * S, f0y = r() * S, ang = r() * Math.PI, len = 4 + r() * 10;
      ctx.strokeStyle = 'rgba(0,0,0,' + (0.03 + r() * 0.04).toFixed(3) + ')'; ctx.lineWidth = 0.6 + r() * 0.6;
      // 端をまたぐ線は反対側にも描いて、敷き詰めたときの継ぎ目を消す
      [[0, 0], [-S, 0], [S, 0], [0, -S], [0, S]].forEach(function (o) {
        ctx.beginPath(); ctx.moveTo(f0x + o[0], f0y + o[1]);
        ctx.quadraticCurveTo(f0x + o[0] + Math.cos(ang) * len * 0.5 + 1.5, f0y + o[1] + Math.sin(ang) * len * 0.5 - 1, f0x + o[0] + Math.cos(ang) * len, f0y + o[1] + Math.sin(ang) * len);
        ctx.stroke();
      });
    }
    return c.toDataURL('image/png');
  }
  // 朝は青み、夕は暖かく、夜は少し暗く。補助文字 #5F5F63 が 4.5:1 を割らない範囲（decisions/17-sensory の表）
  function tint() {
    var h = new Date().getHours();
    var c = h >= 6 && h < 10 ? '250,252,255' : h >= 10 && h < 16 ? '255,255,255' : h >= 16 && h < 19 ? '255,251,244' : '245,245,247';
    paper.style.backgroundColor = 'rgb(' + c + ')';
  }
  if (paper) {
    try { paper.style.backgroundImage = 'url(' + grain() + ')'; } catch (e) {}
    tint(); setInterval(tint, 60000);
  }

  /* ---------- 押したときの波紋 ---------- */
  document.addEventListener('pointerdown', function (e) {
    if (reduce || !e.target.closest) return;
    var t = e.target.closest('.btn, .leaf, .hic, .chip, .sw, .bar a, .herb-list .acts a, .herb-list .acts button');
    if (!t || t.disabled) return;
    var col = getComputedStyle(t).color;
    [0, 1].forEach(function (i) {
      var s = document.createElement('span'); s.className = 'ring' + (i ? ' r2' : ''); s.setAttribute('aria-hidden', 'true');
      s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px'; s.style.color = col;
      document.body.appendChild(s); s.addEventListener('animationend', function () { s.remove(); });
    });
  });

  /* ---------- 葉を摘む ／ Herbarium（標本箱） ---------- */
  var herb = $('#herb'), scrim = $('#herb-scrim'), tpl = $('#leaf-tpl');
  if (!herb || !scrim) return;
  var T = herb.dataset, KEY = 'mf-herbarium', MAX = 60;
  var LEAF = tpl ? tpl.innerHTML : '';
  // localStorage は書き換えられうるので、型と URL の形を確かめてから使う
  function valid(p) {
    return p && typeof p.id === 'string' && /^[A-Za-z0-9-]{1,40}$/.test(p.id) && typeof p.at === 'number' &&
      typeof p.name === 'string' && p.name.length < 200 && typeof p.url === 'string' && /^\/(?!\/)/.test(p.url) &&
      typeof p.img === 'string' && (p.img === '' || /^(https:)?\/\//.test(p.img));
  }
  var raw = store(KEY);
  var picked = (Array.isArray(raw) ? raw : []).filter(valid).slice(-MAX);
  var shown = picked.length, lastFocus = null;
  function has(id) { return picked.some(function (p) { return p.id === id; }); }
  function save() { store(KEY, picked); }

  function leaves() {
    $$('.leaf[data-id]').forEach(function (b) {
      var on = has(b.dataset.id);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', b.dataset.id + ' ' + (on ? T.remove : T.add));
    });
  }
  // 3 枚までは葉を並べ、4 枚目から数字にする
  function counts(grow) {
    $$('.hleaves').forEach(function (box) {
      if (shown <= 3) {
        box.innerHTML = new Array(shown + 1).join(LEAF);
        if (grow && box.lastElementChild) box.lastElementChild.classList.add('pop');
      } else {
        box.textContent = ''; var n = document.createElement('span'); n.className = 'n'; n.textContent = shown; box.appendChild(n);
      }
    });
    $$('.herb-btn').forEach(function (b) { b.setAttribute('aria-label', (T.count || '%n').replace('%n', shown)); });
    var hc = $('.herb-count', herb); if (hc) hc.textContent = picked.length;
  }
  function ymd(ts) { var d = new Date(ts), p = function (n) { return (n < 10 ? '0' : '') + n; }; return p(d.getFullYear() % 100) + '.' + p(d.getMonth() + 1) + '.' + p(d.getDate()); }
  function renderList() {
    var list = $('.herb-list', herb), empty = $('.herb-empty', herb);
    list.textContent = '';
    list.hidden = picked.length === 0; empty.hidden = picked.length > 0;
    picked.slice().reverse().forEach(function (p) {
      var li = document.createElement('li'); li.dataset.id = p.id;
      var a = document.createElement('a'); a.className = 'p'; a.href = p.url; a.tabIndex = -1; a.setAttribute('aria-hidden', 'true');
      if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
      var box = document.createElement('div');
      var num = document.createElement('span'); num.className = 'num'; num.textContent = p.id;
      var name = document.createElement('span'); name.className = 'name'; name.textContent = p.name;
      var when = document.createElement('span'); when.className = 'num'; when.textContent = T.picked + ' ' + ymd(p.at);
      var acts = document.createElement('div'); acts.className = 'acts';
      var view = document.createElement('a'); view.href = p.url; view.textContent = T.view;
      var back = document.createElement('button'); back.type = 'button'; back.dataset.back = p.id; back.textContent = T.back;
      acts.appendChild(view); acts.appendChild(back);
      [num, name, when, acts].forEach(function (n) { box.appendChild(n); });
      li.appendChild(a); li.appendChild(box); list.appendChild(li);
    });
  }
  function visibleHerbBtn() { return $$('.herb-btn').filter(function (b) { return b.offsetParent !== null; })[0]; }
  function bump(el) { if (!el) return; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  function fly(from, done) {
    var to = visibleHerbBtn(), svg = from.querySelector('svg');
    if (!to || !svg || reduce || !Element.prototype.animate) { done(); return; }
    var a = svg.getBoundingClientRect(), b = to.getBoundingClientRect();
    var el = document.createElement('div'); el.className = 'flyleaf'; el.innerHTML = LEAF;
    el.style.left = a.left + 'px'; el.style.top = a.top + 'px'; document.body.appendChild(el);
    var dx = (b.left + b.width * 0.3) - a.left, dy = (b.top + b.height / 2 - 11) - a.top;
    // 枝から離れて一度ふわりと上がり、回りながら Herbarium に落ちる
    var an = el.animate([
      { transform: 'translate(0,0) rotate(0deg) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.22 + 'px,' + (dy * 0.2 - 64) + 'px) rotate(-140deg) scale(1.2)', opacity: 1, offset: 0.35 },
      { transform: 'translate(' + dx * 0.72 + 'px,' + (dy * 0.75 - 30) + 'px) rotate(-290deg) scale(.85)', opacity: 1, offset: 0.75 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(-360deg) scale(.45)', opacity: 0 }
    ], { duration: 750, easing: 'cubic-bezier(.35,.1,.25,1)' });
    an.onfinish = an.oncancel = function () { el.remove(); done(); };
  }
  function toggle(b) {
    var id = b.dataset.id;
    if (has(id)) {
      picked = picked.filter(function (p) { return p.id !== id; });
      shown = picked.length; save(); leaves(); counts(); renderList();
      return;
    }
    var entry = { id: id, name: b.dataset.name || id, img: b.dataset.img || '', url: b.dataset.url || '/', at: Date.now() };
    if (!valid(entry)) return;
    picked.push(entry); if (picked.length > MAX) picked.shift();
    save(); leaves(); renderList();
    fly(b, function () { shown = picked.length; counts(true); if (has(id)) bump(visibleHerbBtn()); });
  }

  function isOpen() { return !herb.hidden; }
  function open() {
    if (isOpen()) return;
    // カートの引き出しが開いていたら先に閉じる（同じ右側に重なるため）
    var cd = $('#cart-drawer .drawer'); if (cd && !cd.hidden) { var cc = $('#cart-drawer .close'); if (cc) cc.click(); }
    lastFocus = document.activeElement;
    renderList();
    herb.hidden = false; scrim.hidden = false; html.classList.add('lock-herb');
    requestAnimationFrame(function () { herb.classList.add('on'); });
    $$('.herb-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = $('.close', herb); if (c) c.focus();
  }
  function close() {
    if (!isOpen()) return;
    herb.classList.remove('on'); scrim.hidden = true; html.classList.remove('lock-herb');
    $$('.herb-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!herb.classList.contains('on')) herb.hidden = true; }, reduce ? 0 : 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var leaf = e.target.closest('.leaf[data-id]');
    if (leaf) { e.preventDefault(); toggle(leaf); return; }
    if (e.target.closest('.herb-btn')) { isOpen() ? close() : open(); return; }
    if (e.target.closest('#herb .close, #herb-scrim')) { close(); return; }
    var back = e.target.closest('#herb [data-back]');
    if (back) {
      var items = $$('#herb [data-back]'), idx = items.indexOf(back);
      picked = picked.filter(function (p) { return p.id !== back.dataset.back; });
      shown = picked.length; save(); leaves(); counts(); renderList();
      var rest = $$('#herb [data-back]'); (rest[Math.min(idx, rest.length - 1)] || $('.close', herb)).focus();
      return;
    }
    if (e.target.closest('.bag-link') && isOpen()) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
  // 別のタブで摘んだ分も合わせる
  addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    var r = store(KEY); picked = (Array.isArray(r) ? r : []).filter(valid).slice(-MAX);
    shown = picked.length; leaves(); counts(); renderList();
  });

  leaves(); counts(); renderList();
})();
